module.exports = __webpack_public_path__ + "img/bomberBP_TH copy.c6e390c7.png";